<template>
  <div @click="showDialog">
    <v-layout row wrap justify-space-around>
      <!--calendar-->
      <v-flex xs3 sm2 text-xs-center>
        <!--session date-->
        <time
          :datetime="submission.sessionDate"
          class="icon"
          style="margin: auto; margin-bottom: 5px;">
          <em :class="{'error--text': isAbsent}">{{ date.year }}</em>
          <strong
            :class="{
              'month': !isAbsent,
              'month-absent': isAbsent
            }">
            {{ date.month }}
          </strong>
          <span>{{ date.date }}</span>
        </time>
        <span v-if="isAbsent" class="error--text">ABSENT</span>
        <!--start time-->
        <div class="pt-1">
          {{ submission.sessionTime | militaryTimeToStandard }}
        </div>
        <!--sessionMinutes-->
        <span v-if="submission.sessionMinutes">
          <small>({{ submission.sessionMinutes }} mins)</small>
        </span>
      </v-flex>
      <!--student information-->
      <v-flex text-xs-left xs9 sm10 md7>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <div
              class="font-weight-bold"
              :class="{'body-2': isMobile}">
              {{ submission.studentFirstName }}
              {{ submission.studentLastName }}
              ({{ submission.studentExtId }})
            </div>
            <div :class="{'caption': isMobile}">
              {{ submission.studentSchoolName }} ({{ submission.grade }})
            </div>
            <div :class="{'caption': isMobile}">
              {{ submission.locationName }}
              <span v-if="submission.locationOther">
                - {{ submission.locationOther }}
              </span>
            </div>
          </v-flex>
          <v-flex xs12 sm6 :class="{'pt-3': isMobile}">
            <div :class="{'caption': isMobile}">
              {{ submission.planTypeName }}: {{ submission.serviceType }}
            </div>
            <div :class="{'caption': isMobile}">
              {{ submission.serviceStartDate | formatDate}}
              -
              {{ submission.serviceEndDate | formatDate}}
            </div>
            <div :class="{'caption': isMobile}" v-if="submission.serviceEsy">(ESY)</div>
            <div :class="{'caption': isMobile}">
              {{ submission.providerFirstName + ' ' + submission.providerLastName }}
              <span v-if="submission.providerCredential">
                /
                <span>
                  {{ submission.providerCredential }}
                </span>
                <span v-if="submission.supervisorFlag">
                  <v-icon
                    size="small"
                    color="green">mdi-checkbox-marked-circle
                  </v-icon>
                </span>
              </span>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md3 :class="{'mt-2': isMobile}">
        <action-icons
          v-on:service-log:deleted="deleteServiceLog"
          :submission="submission"></action-icons>
      </v-flex>
    </v-layout>
    <div v-if="confirmationDialog">
      <submission-history
        :submission="submission"
        v-on:dialog:closed="confirmationDialog = false"
        v-on:reload:page="deleteServiceLog">
      </submission-history>
    </div>
  </div>
</template>

<script>
import ActionIcons from '@/components/action-icons';
import SubmissionHistory from '@/components/service-log/history/submission-history-dialog';
import * as Constants from '@/constants';

export default {
  name: 'HistoryRepeatable',
  components: {
    ActionIcons,
    SubmissionHistory
  },
  props: ['submission', 'loadData'],
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    },
    isAbsent() {
      return Constants.IS_ABSENT(this.submission.absentType);
    }
  },
  data() {
    return {
      confirmationDialog: false,
      date: {
        month: '',
        date: '',
        year: ''
      }
    };
  },
  methods: {
    showDialog() {
      this.confirmationDialog = true;
    },
    setDate() {
      const [year, month, date] = this.submission.sessionDate.split('-');
      this.date.year = year;
      this.date.month = month;
      this.date.date = date;
      switch (month.toString()) {
        case '01':
          this.date.month = 'January';
          break;
        case '02':
          this.date.month = 'February';
          break;
        case '03':
          this.date.month = 'March';
          break;
        case '04':
          this.date.month = 'April';
          break;
        case '05':
          this.date.month = 'May';
          break;
        case '06':
          this.date.month = 'June';
          break;
        case '07':
          this.date.month = 'July';
          break;
        case '08':
          this.date.month = 'August';
          break;
        case '09':
          this.date.month = 'September';
          break;
        case '10':
          this.date.month = 'October';
          break;
        case '11':
          this.date.month = 'November';
          break;
        default:
          this.date.month = 'December';
          break;
      }
    },
    deleteServiceLog() {
      this.$emit('service-log:deleted');
    }
  },
  mounted() {
    this.setDate();
  },
  watch: {
    loadData() {
      this.setDate();
    }
  }
};
</script>

<style lang="scss" scoped>
  time.icon {
    font-size: .6em; /* change icon size */
    display: block;
    position: relative;
    width: 7em;
    height: 7em;
    background-color: #fff;
    border-radius: 0.6em;
    box-shadow: 0 1px 0 #bdbdbd, 0 2px 0 #fff, 0 3px 0 #bdbdbd, 0 4px 0 #fff, 0 5px 0 #bdbdbd, 0 0 0 1px #bdbdbd;
    overflow: hidden;
    -webkit-backface-visibility: hidden;
    -webkit-transform: rotate(0deg) skewY(0deg);
    -webkit-transform-origin: 50% 10%;
    transform-origin: 50% 10%;
    margin-bottom: 10px;
  }

  time.icon * {
    display: block;
    width: 100%;
    font-size: 1em;
    font-weight: bold;
    font-style: normal;
    text-align: center;
  }

  time.icon strong.month {
    position: absolute;
    top: 0;
    padding: 0.4em 0;
    color: #fff;
    background-color: var(--v-secondary-base);
    border-bottom: 1px dashed white;
    box-shadow: 0 2px 0 var(--v-secondary-base);
  }

  time.icon strong.month-absent {
    position: absolute;
    top: 0;
    padding: 0.4em 0;
    color: #fff;
    background-color: var(--v-error-base);
    border-bottom: 1px dashed white;
    box-shadow: 0 2px 0 var(--v-error-base);
  }

  time.icon em {
    position: absolute;
    bottom: 0;
    color: var(--v-primary-base);
  }

  time.icon span {
    width: 100%;
    font-size: 2.8em;
    letter-spacing: -0.05em;
    padding-top: 0.8em;
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/service-log/history/history-repeatable.vue